"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _UIBreakString = _interopRequireDefault(require("UIComponents/text/UIBreakString"));

var _SanitizedText = _interopRequireDefault(require("sanitize-text/components/SanitizedText"));

var Benefits = function Benefits(_ref) {
  var benefits = _ref.benefits;
  return _react.default.createElement(_UIBreakString.default, null, _react.default.createElement(_SanitizedText.default, {
    body: benefits
  }));
};

Benefits.propTypes = {
  benefits: _propTypes.default.string.isRequired
};
var _default = Benefits;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/detail/overview/Benefits.js
// module id = 804
// module chunks = 209 210 211 212